import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ThemeColors {
  bg: string
  fg: string
  color1: string
  color2: string
}

interface ThemeState {
  userTheme: ThemeColors | null
  setUserTheme: (theme: ThemeColors | null) => void
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set) => ({
      userTheme: null,
      setUserTheme: (theme) => {
        set({ userTheme: theme })
        if (theme) {
          const style = document.getElementById('user-theme-override') || document.createElement('style')
          style.id = 'user-theme-override'
          style.textContent = `:root{--color-bg:${theme.bg};--color-fg:${theme.fg};--color-1:${theme.color1};--color-2:${theme.color2};}`
          document.head.appendChild(style)
        } else {
          document.getElementById('user-theme-override')?.remove()
        }
      },
    }),
    { name: 'abaddon-theme' }
  )
)
